import React, {Component} from 'react';
import {
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  ListGroup,
  ListGroupItem,
  Input,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap'

const sprintf = require('sprintf-js').sprintf;
const isOnLOP = require('../utilities/isOnLOP');
const R = require('ramda')

class Rosters extends Component {

  constructor(props) {
    super(props);
    this.changeRosterType = this.changeRosterType.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.onRosterClick = this.onRosterClick.bind(this);
    this.goToStudent = this.goToStudent.bind(this);
    this.addRoster = this.addRoster.bind(this);
    this.editRoster = this.editRoster.bind(this);
    this.toggleEditRosterModal = this.toggleEditRosterModal.bind(this);
    this.onChange = this.onChange.bind(this);
    this.saveRoster = this.saveRoster.bind(this);
    this.state = {
      rosterType: 'class',       // or 'custom'
      scheduleRosters: [],
      scheduleRosterKeys: [],
      selectedScheduleRosterKey: '',
      customRosters: [],
      customRosterKeys: [],
      selectedCustomRosterKey: '',
      filter: '',
      editRosterModal: false,
      rosterName: '',
      ids: '',
    }
  }

  componentDidMount() {
    let _this = this;
    this.props.db.ref('schedules').once('value', snap => {
      let scheduleRosters = R.flatten(R.values(snap.val()));
      scheduleRosters = R.reduce((acc, s) => {
        let key = s.teacher+' | Per '+s.period + ' | ' + s.course;
        if (!acc[key]) {
          acc[key] = []
        }
        acc[key].push(s);
        return acc;
      }, {}, scheduleRosters);
      let scheduleRosterKeys = R.sort((a,b) => a < b ? -1 : 1, R.keys(scheduleRosters))
      _this.setState({scheduleRosters, scheduleRosterKeys})
    })
    let customRef = 'rosters';
    this.props.db.ref(customRef).on('value', snap => {
      let customRosters = snap.val();
      // if (_this.props.user.permissionFlags.ROSTERS === 'false') {
      //   customRosters = R.assoc(_this.props.user.name, customRosters, {})
      // }
      customRosters = R.reduce((summary, user) => {
        return R.reduce((summary, roster) => {
          let key = user+' | '+roster;
          summary = R.assoc(key, customRosters[user][roster], summary);
          return summary
        }, summary, R.keys(customRosters[user]))
      }, {}, R.keys(customRosters));
      _this.setState({customRosters, customRosterKeys: R.keys(customRosters)})
    })
  }

  changeRosterType(evt) {
    if (this.state.rosterType === 'custom') {
      this.setState({rosterType: 'class'})
    } else if (this.state.rosterType === 'class') {
      this.setState({rosterType: 'custom'})
    }
  }

  onChangeFilter(evt) {
    this.setState({filter: evt.currentTarget.value});
  }

  onRosterClick(evt) {
    if (this.state.rosterType === 'class') {
      this.setState({selectedScheduleRosterKey: evt.currentTarget.getAttribute('data-key')})
    } else {
      this.setState({selectedCustomRosterKey: evt.currentTarget.getAttribute('data-key')})
    }
  }

  getRosterList(rosterKeys, selectedRosterKey, onRosterClick) {
    return (
      <ListGroup className="list-scroll roster-details cursor-pointer">
        {
          rosterKeys.map((key, idx) => {
            return (
              <ListGroupItem active={key && key === selectedRosterKey}
                             key={key}
                             data-key={key}
                             onClick={onRosterClick}>
                <Row>
                  <Col md={12}>
                    {key}
                  </Col>
                </Row>
              </ListGroupItem>
            );
          })
        }
      </ListGroup>
    )
  }

  addRoster() {
    this.setState({
      editRosterModal: true,
      rosterName: '',
      ids: ''
    })
  }

  editRoster() {
    this.setState({
      editRosterModal: true,
      rosterName: this.state.selectedCustomRosterKey.split(' | ')[1].trim(),
      ids: this.state.customRosters[this.state.selectedCustomRosterKey]
    })
  }

  onChange(evt) {
    let field = evt.currentTarget.getAttribute('name');
    if (field === 'rosterName') {
      this.setState({rosterName: evt.currentTarget.value.replace('#','')})
    } else if (field === 'ids') {
      this.setState({ids: evt.currentTarget.value.split('\r').join(',')})
    }
  }

  saveRoster() {
    let _this = this;
    this.props.db.ref('rosters/'+this.props.user.name+'/'+this.state.rosterName).set(this.state.ids.split('\n').join(','), err => {
      _this.setState({editRosterModal: false});
    });
  }

  toggleEditRosterModal() {
    this.setState({editRosterModal: !this.state.editRosterModal})
  }

  goToStudent(evt) {
    let stuID = evt.currentTarget.getAttribute('data-key');
    this.props.dispatch('DATA:SELECT_STUDENT', stuID);
  }

  render() {
    let _this = this;
    let modalInvalid = !(this.state.rosterName.length > 0 && this.state.ids.length > 0);
    let userName = this.state.selectedCustomRosterKey.split(' | ')[0].trim();
    let editShow = userName === this.props.user.name;
    let editInvalid = this.state.selectedCustomRosterKey.length === 0;
    let rosters = [], rosterKeys = [];
    if (this.state.rosterType === 'class') {
      let scheduleRosterKeys = (this.state.scheduleRosterKeys) ? this.state.scheduleRosterKeys : []
      scheduleRosterKeys = R.filter(key => {
        return R.includes(_this.state.filter.toLowerCase(), key.toLowerCase())
      }, scheduleRosterKeys);
      rosterKeys = scheduleRosterKeys;
      rosters = this.state.scheduleRosters[this.state.selectedScheduleRosterKey] || [];
      rosters = R.map(stu => {
        let s = _this.props.studentObjs[stu.studentID];
        if (s) {
          stu.student = _this.props.studentObjs[stu.studentID];
          stu.onLOP = isOnLOP(stu.student);
          return stu;
        } else {
          return null
        }
      }, rosters)
    } else if (this.state.rosterType === 'custom') {
      rosterKeys = this.state.customRosterKeys;
      rosterKeys = R.filter(key => {
        return R.includes(_this.state.filter.toLowerCase(), key.toLowerCase())
      }, rosterKeys);
      if (this.state.selectedCustomRosterKey === '') {
        rosters = []
      } else {
        rosters = this.state.customRosters[this.state.selectedCustomRosterKey].split(',');
        rosters = R.map(id => {
          let student = _this.props.studentObjs[id];
          return {
            studentID: id,
            student,
            onLOP: isOnLOP(student)
          }
        }, rosters);
      }
    }
    rosters = R.filter(s => s, rosters);
    rosters = R.sort((a,b) => {
      if (!a.student || !b.student) {
        return 1
      } else {
        return (a.student.lastName+','+a.student.firstName < b.student.lastName+','+b.student.firstName) ? -1 : 1
      }
    }, rosters)

    rosters = R.map(stu => {
      if (stu.student) {
        return (
          <tr key={stu.studentID}>
            <td className={(stu.onLOP) ? "on-lop text-center" : "text-center"}>{(stu.onLOP) ? 'ON': ''}</td>
            <td className={(stu.onLOP) ? "on-lop text-center" : "text-center"}>{stu.studentID}</td>
            <td onClick={_this.goToStudent} data-key={stu.studentID}
                className={(stu.onLOP) ? "on-lop cursor-pointer" : "cursor-pointer"}>{stu.student.lastName + ', ' + stu.student.firstName}</td>
            <td className="text-center">{stu.student.classOf + ' | ' + sprintf('%02d', stu.student.grade)}</td>
            <td
              className={(stu.student.acGPA < 2.0) ? "text-center on-lop" : "text-center"}>{sprintf('%4.2f', stu.student.acGPA)}</td>
            <td
              className={(stu.student.citGPA < 2.0) ? "text-center on-lop" : "text-center"}>{sprintf('%4.2f', stu.student.citGPA)}</td>
            <td className={(stu.student.finance) ? "text-center on-lop" : "text-center"}>{(stu.student.finance) ?
              <span className="on-lop">{`\u2588`}</span> : <span className="off-lop-green">{`\u2588`}</span>}</td>
            <td className={(stu.student.library) ? "text-center on-lop" : "text-center"}>{(stu.student.library) ?
              <span className="on-lop">{`\u2588`}</span> : <span className="off-lop-green">{`\u2588`}</span>}</td>
            <td
              className={(stu.student.lopCount > 0) ? "text-center on-lop" : "text-center"}>{stu.student.lopCount}</td>
          </tr>
        )
      } else {
        return (
          <tr key={stu.studentID}>
            <td></td>
            <td className="text-center">{stu.studentID}</td>
            <td colSpan={7}>Student ID not found</td>
          </tr>
        )
      }
    }, rosters)
    return (
      <div>
        <Row className="master-detail-top-separator">
          <Col md={4}>
            <Form>
              {
                (this.props.user.permissionFlags.ROSTERS === 'true') ?
                  <FormGroup row>
                    <Label for="rosterType" md={6}>Roster type:</Label>
                    <Col md={6}>
                      <Input type="select" onChange={this.changeRosterType} value={this.state.rosterType}>
                        <option value="class">Class</option>
                        <option value="custom">Custom</option>
                      </Input>
                    </Col>
                  </FormGroup> : null
              }
              <FormGroup row>
                <Label for="filter" md={6}>Filter on teacher or class</Label>
                <Col md={6}>
                  <Input type="filter" onChange={this.onChangeFilter} value={this.state.filter} />
                </Col>
              </FormGroup>
            </Form>
            {
              this.getRosterList(rosterKeys, (this.state.rosterType === 'class') ? this.state.selectedScheduleRosterKey : this.state.selectedCustomRosterKey, this.onRosterClick)
            }
          </Col>
          <Col md={8}>
            {
              (this.state.rosterType === 'custom') ?
                <Row>
                  <Col md={6}>
                    <Button color="primary" onClick={this.addRoster}>Add</Button>
                  </Col>
                  {
                    (editShow) ?
                      <Col md={6} className="text-right">
                        <Button color="primary" onClick={this.editRoster} disabled={editInvalid}>Edit</Button>
                      </Col> : null
                  }
                </Row> : null
            }
            {
              ((this.state.rosterType === 'class' && this.state.selectedScheduleRosterKey.length > 0) ||
                (this.state.rosterType === 'custom' && this.state.selectedCustomRosterKey.length > 0)) ?
                <Table size="sm" className="top-spacer list-scroll roster-details">
                  <thead>
                    <tr>
                      <th className="text-center">On LOP</th>
                      <th className="text-center">Stu ID</th>
                      <th>Name</th>
                      <th className="text-center">C/O | Gr</th>
                      <th className="text-center">Ac GPA</th>
                      <th className="text-center">Cit GPA</th>
                      <th className="text-center">Fin</th>
                      <th className="text-center">Lib</th>
                      <th className="text-center">LOP records</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rosters}
                  </tbody>
                </Table> : null
            }
          </Col>
        </Row>

        <Modal isOpen={this.state.editRosterModal}>
          <ModalHeader toggle={this.toggleEditRosterModal}>Edit roster</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup row>
                <Label md={4} for="name">Roster name:</Label>
                <Col md={8}>
                  <Input type="text" name="rosterName" id="rosterName" onChange={this.onChange} value={this.state.rosterName} placeholder="Roster name" />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label md={4} for="ids">Student IDs:</Label>
                <Col md={8}>
                  <Input type="textarea" name="ids" id="ids" className="student-ids" onChange={this.onChange} value={this.state.ids.split(',').join('\n')} placeholder="Enter one ID number per line" />
                </Col>
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" disabled={modalInvalid} onClick={this.saveRoster}>Save</Button>{' '}
            <Button color="primary" onClick={this.toggleEditRosterModal}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }

}

export default Rosters



// WEBPACK FOOTER //
// ./src/views/Rosters.js